'use strict';

/**
 * @function
 * @description Binds the onclick-event to a delete button on a given container,
 * which opens a confirmation box with a given message
 * @param {String} container The name of element to which the function will be bind
 * @param {String} message The message the will be shown upon a click
 */
const setDeleteConfirmation = (container, message) => {
    $(container).on('click', '.delete', function () {
        return window.confirm(message);
    });
};

module.exports = setDeleteConfirmation;
